import {
  filter,
  isEmpty,
  isNil,
  map,
  propEq
} from 'ramda'
import React,
{ Component } from 'react'
import { connect } from 'react-redux'

import { Button } from '@driftt/dds'
import {
  Input,
  Modal
} from '@driftt/tide-core'
import { Select } from '@driftt/tide-selects'
import { getStaticSegments } from 'api/segments'

const mapStateToProps = state => ({ orgId: state.user.orgId })

class StaticSegmentModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      creatingNew: true,
      addingToExisting: false,
      segmentName: '',
      staticSegmentsLoaded: false,
      staticSegments: [],
      selectedSegment: null
    }
  }

  componentDidMount() {
    this.getStaticSegments()
  }

  getStaticSegments = async () => {
    const { orgId } = this.props

    try {
      const { data } = await getStaticSegments(orgId)

      const staticSegments = filter(propEq('type', 'ID_LIST'), data)

      this.setState({
        staticSegments: map(segment => ({
          label: segment.name,
          value: segment.id
        }), staticSegments),
        staticSegmentsLoaded: true
      })
    } catch(e) {
      console.log(e)
    }
  }

  saveSegment = () => {
    const {
      creatingNew,
      selectedSegment,
      segmentName
    } = this.state
    const {
      saveAsNew,
      addToExisting,
      onClose
    } = this.props

    if (creatingNew) {
      saveAsNew(segmentName)
      onClose()
    } else {
      addToExisting(selectedSegment)
      onClose()
    }
  }

  modifyExistingSegment = ({ value }) => {
    this.setState({
      creatingNew: false,
      addingToExisting: true,
      selectedSegment: value
    })
  }

  setSegmentName = (event) => {
    const name = event.target.value

    this.setState({ segmentName: name })
  }

  createNewSegment = () => {
    this.setState({
      creatingNew: true,
      addingToExisting: false,
      selectedSegment: null
    })
  }

  render() {
    const {
      open,
      onClose,
      numberOfSelectedContacts
    } = this.props
    const {
      segmentName,
      creatingNew,
      staticSegmentsLoaded,
      staticSegments,
      addingToExisting,
      selectedSegment
    } = this.state

    const title = `Add ${numberOfSelectedContacts} contact${numberOfSelectedContacts > 1 ? 's' : ''} to segment`
    const selectValue = staticSegments.filter(({ value }) => value === selectedSegment)
    console.log(staticSegments)
    return (
      <Modal
        open={open}
        size="small"
        onClose={onClose}
        className="contacts-static-segment-modal"
      >
        <div className="contacts-static-segment-modal-body">
          <h2 className="contacts-static-segment-modal-title">{title}</h2>
          <Input
            type="checkbox"
            checked={creatingNew}
            onChange={this.createNewSegment}
            label="Create a new static segment"
          />
          <Input
            type="text"
            onChange={this.setSegmentName}
            value={segmentName}
            className="contacts-static-segment-modal-segment-name"
            label="This segment will contain only the contacts you’ve selected"
            placeholder="Segment name"
            disabled={!creatingNew}
          />
          <Input
            type="checkbox"
            checked={addingToExisting}
            onChange={this.modifyExistingSegment}
            label="Add to existing segment"
          />
          {!!staticSegmentsLoaded &&
            <Select
              className="contacts-static-segment-modal-segment-select"
              options={staticSegments}
              value={selectValue}
              onChange={this.modifyExistingSegment}
              disabled={creatingNew}
              tethered
            />
          }
        </div>
        <footer className="contacts-static-segment-modal-footer">
          <Button  disabled={(creatingNew ? isEmpty(segmentName) : isNil(selectedSegment))}
            onClick={this.saveSegment}>
            {`${creatingNew ? 'Create new segment' : 'Add to segment'}`}
          </Button>
        </footer>
      </Modal>
    )
  }
}

export default connect(mapStateToProps, null)(StaticSegmentModal)
